import React from 'react';
import useDialog from './useDialog';
import { Close, Check } from '@material-ui/icons';
import { Dialog as MuiDialog, DialogTitle, DialogContent, DialogActions, ButtonGroup, Button, ButtonProps } from '@material-ui/core';
import './styles.scss';

const Dialog: React.FC = () => {
  const { dialog, closeDialog } = useDialog();
  if (!dialog) return null;

  const { dialogTitle, dialogContent, dialogConfirm, muiDialogProps } = dialog;
  const { onConfirm, confirmText, ...muiButtonProps } = dialogConfirm;

  const confirmButtonProps: ButtonProps = {
    startIcon: <Check />,
    variant: 'contained',
    color: 'primary',
    ...muiButtonProps
  };

  const handleConfirm = () => {
    onConfirm();
    closeDialog();
  };

  return (
    <MuiDialog
        open={!!dialog}
        onClose={closeDialog}
        {...{
            className: 'global-dialog',
            ...muiDialogProps
        }}
    >
        <DialogTitle>{dialogTitle}</DialogTitle>
        <DialogContent>{dialogContent}</DialogContent>
        <DialogActions>
            <ButtonGroup>
                {!!dialogConfirm && (
                    <Button
                        onClick={handleConfirm}
                        {...confirmButtonProps}
                    >
                        {dialogConfirm.confirmText}
                    </Button>
                )}
                <Button
                    onClick={closeDialog}
                    startIcon={<Close />}
                >
                    Отмена
                </Button>
            </ButtonGroup>
        </DialogActions>
    </MuiDialog>
  )
};

export default Dialog;